import "react-app-polyfill/stable";
import "core-js";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { createTheme, responsiveFontSizes, ThemeProvider } from "@mui/material/styles";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";

const persistor = persistStore(store);

let theme = createTheme({
    typography: {
        fontFamily: ["Plus Jakarta Sans", "system-ui", "sans-serif"].join(","),
    },
    shape: {
        borderRadius: 8,
    },
    palette: {
        primary: {
            main: "#142033",
        },
        secondary: {
            main: "#ec6a4b",
        },
        white: {
            main: "##005e99",
            overrides: {
                MuiButton: {
                    label: {
                        color: "#ffffff",
                    },
                },
            },
        },
        black: {
            main: "#142033",
        },
        grey: {
            main: "#2C384AAE",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 700,
                },
            },
            variants: [
                {
                    props: { variant: "blue" },
                    style: {
                        backgroundColor: "#142033",
                        color: "#ffffff",
                        fontWeight: 700,
                        transition: "all .35s",
                        "&:hover": {
                            background: "#1e2f4d",
                        },
                    },
                },
            ],
        },
    },
});

theme = responsiveFontSizes(theme);

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </PersistGate>
    </Provider>,
    document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
